import React, { useState, useEffect } from 'react';
import { Card, Container, Row, Form, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import { useNavigate } from 'react-router-dom';

import { toast } from 'react-toastify';

import { useAuth } from '../Context/AuthContext';
import StatusSpinner from '../Components/StatusSpinner';

import { db } from '../firebase-config';
import { onSnapshot, doc } from 'firebase/firestore';

const ClientProfile = ()=>{
    const { currentUserInfo, setShowSpinner, showSpinner } = useAuth();
    const [clientLocations, setClientLocations ] = useState([]);
    const navigate = useNavigate();

    useEffect(()=>{
        setShowSpinner(true);
        let unsubscribe = ()=>{};
        if(currentUserInfo?.links?.client){
            const clientInfoRef = doc(db, "client_information", currentUserInfo.links.client)
            unsubscribe = onSnapshot(clientInfoRef, (clientSnapShot)=>{
                if(clientSnapShot.exists()){
                    let tempClientLocations = [];
                    tempClientLocations = clientSnapShot.data().Locations
                        .filter(location => currentUserInfo.links.locations.includes(location.id))
                        .map(({
                            "Additional Contacts": additionalContacts,
                            "Address": address,
                            "Client Name": clientName,
                            "Email Address": emailAddress,
                            "Phone Number": phoneNumber,
                            "Invoices": invoices
                        }) => ({
                            additionalContacts,
                            address,
                            clientName,
                            emailAddress,
                            phoneNumber,
                            invoices
                        }));
                    setClientLocations(tempClientLocations);
                    setShowSpinner(false);
                }else{
                    toast.error(`Client does not exixt in database, please contact the Provengroup`);
                }
            },(error)=>{
                toast.error(`Failed to load client database: ${error.message}`);
                setShowSpinner(false);
            });
        }else{
            setClientLocations([]);
            setShowSpinner(false);
        }

        return ()=>{
            unsubscribe();
        }
    },[setShowSpinner, currentUserInfo]);
    
    return(
        <>
            <div style={{display: 'flex', flexDirection: "row", alignItems:"center", justifyContent:"center", position:"relative"}}>
                <div className="mt-5" style={{position:"absolute", left:0}}>
                    <Button
                        className="btn-dark"
                        style={{backgroundColor:"#FFFFFF", border:"none", width: 75, marginLeft: 20}}
                        onClick={()=>{
                            navigate("/client");
                        }}
                        >
                        <FontAwesomeIcon style={{color: "#2596be", fontSize: '1.5em'}} icon={faArrowLeft} />
                        <span style={{color:"black"}}>HOME</span>
                    </Button>
                </div>
                <div className="mt-5" style={{fontSize:"1.5em", letterSpacing:"0.2em"}}>PROFILE</div>     
            </div>
            <Container fluid style={{width:"100%", marginBottom:"50px" }}>
                <Container fluid className="mt-4">
                    <Row className="justify-content-md-center">
                        <Col lg="6">
                            <Card style={{border:"1px solid black"}}>
                                <Card.Header style={{textAlign:"center"}}>LOCATIONS: CONTACT INFORMATION</Card.Header>
                                <Card.Body style={{textAlign:"left"}}>
                                    <ol>
                                    {
                                        clientLocations.map((location, index)=>{
                                            return(
                                                <li key={index}>
                                                    <Row style={{marginLeft:"10px", marginBottom:"20px"}}>
                                                        <Row>
                                                            <Col>
                                                                LOCATION
                                                            </Col>
                                                        </Row>
                                                        <Row style={{marginBottom:"10px"}}>
                                                            <Col>
                                                                <Form.Control
                                                                    className="mt-1"
                                                                    type="text"
                                                                    value={location?.address === undefined ? "" : location.address}
                                                                    disabled={true}
                                                                />
                                                            </Col>
                                                        </Row>
                                                        <Row><Col>CONTACTS</Col></Row>
                                                        <ol type="A" style={{marginLeft:'10px'}}>
                                                            <li>
                                                                <Row><Col>CLIENT NAME (AUTHORIZATION/CONTACT)</Col></Row>
                                                                <Row style={{marginBottom:"10px"}}>
                                                                    <Col>
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={location?.clientName === undefined ? "" : location.clientName}
                                                                            disabled={true}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                                <Row><Col>EMAIL ADDRESS</Col></Row>
                                                                <Row style={{marginBottom:"10px"}}>
                                                                    <Col>
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={location?.emailAddress === undefined ? "" : location.emailAddress}
                                                                            disabled={true}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                                <Row><Col>PHONE NUMBER</Col></Row>
                                                                <Row style={{marginBottom:"10px"}}>
                                                                    <Col>
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={location?.phoneNumber === undefined ? "" : location.phoneNumber}
                                                                            disabled={true}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            </li>
                                                            {
                                                                location?.additionalContacts === undefined || location?.additionalContacts.length === 0 ?
                                                                    ""
                                                                :
                                                                    location.additionalContacts.map((additionalContact, additionalIndex)=>{
                                                                        return(
                                                                            <li key={additionalIndex}>
                                                                                <Row><Col>CLIENT NAME</Col></Row>
                                                                                <Row style={{marginBottom:"10px"}}>
                                                                                    <Col>
                                                                                        <Form.Control
                                                                                            type="text"
                                                                                            value={additionalContact?.["Client Name"] === undefined ? "" : additionalContact["Client Name"]}
                                                                                            disabled={true}
                                                                                        />
                                                                                    </Col>
                                                                                </Row>
                                                                                <Row><Col>EMAIL ADDRESS</Col></Row>
                                                                                <Row style={{marginBottom:"10px"}}>
                                                                                    <Col>
                                                                                        <Form.Control
                                                                                            type="text"
                                                                                            value={additionalContact?.["Email Address"] === undefined ? "" : additionalContact["Email Address"]}
                                                                                            disabled={true}
                                                                                        />
                                                                                    </Col>
                                                                                </Row>
                                                                                <Row><Col>PHONE NUMBER</Col></Row>
                                                                                <Row style={{marginBottom:"10px"}}>
                                                                                    <Col>
                                                                                        <Form.Control
                                                                                            type="text"
                                                                                            value={additionalContact?.["Phone Number"] === undefined ? "" : additionalContact["Phone Number"]}
                                                                                            disabled={true}
                                                                                        />
                                                                                    </Col>
                                                                                </Row>
                                                                            </li>
                                                                        )
                                                                    })
                                                            }
                                                        </ol>
                                                    </Row>
                                                </li>
                                            )
                                        })
                                    }
                                    </ol>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Container>
            {
                showSpinner &&
                <StatusSpinner />
            }
        </>
    )
};

export default ClientProfile;